export default "__VITE_ASSET__CSaubbSy__"